import React from 'react'

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { MooncakeTheme } from '../theme'

export type TabProps = {
  children: React.ReactNode
  selected?: boolean
  href?: string
  onClick?: () => void
  id?: string
  'aria-controls'?: string
}

const selected = (theme: MooncakeTheme) => css`
  color: ${theme.colors.label};

  &::after {
    background-color: ${theme.colors.primary};
  }
`

const TabContainer = styled.button<TabProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  font-weight: ${props => props.theme.weights.medium};
  height: 3rem;
  position: relative;
  color: ${props => props.theme.colors.disabledLabel};
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  font-size: 1rem;
  -webkit-tap-highlight-color: transparent;

  outline-style: none;

  ${props => props.theme.selectors.keyboard} &:focus {
    outline-style: auto;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 0.25rem;
  }

  ${props => props.selected && selected(props.theme)};

  @media (hover: hover) {
    :hover {
      ${props => selected(props.theme)}
    }
  }
`

const Tab: React.FC<TabProps> = props => {
  const inferredProps = props.href
    ? {
        as: 'a' as const,
      }
    : {
        role: 'tab',
        tabIndex: -1,
        'aria-selected': props.selected,
      }
  return <TabContainer {...inferredProps} {...props} />
}

export default Tab
